import UsersService from '@/services/modules/users.service';

const add = async ({ commit }, _object) => {
    const response = UsersService.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }, _param) => {
    const response = UsersService.all(_param);

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const edit = async ({ commit }, _object) => {
    const response = UsersService.edit(_object.id, _object);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = UsersService.get(_id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};

const getAfterSales = async ({ commit }) => {
    const response = UsersService.getByTypeProfile(UsersService.typeProfiles.after_sales, "");

    response.then(function (_response) {
        commit('setListAfterSales', _response);
    });

    return response;
};

const getManagers = async ({ commit }) => {
    const response = UsersService.getByTypeProfile(UsersService.typeProfiles.manager, "");

    response.then(function (_response) {
        commit('setListManagers', _response);
    });

    return response;
};

const getSalesmans = async ({ commit }, _object) => {
    var filters = "";
    if (_object !== undefined && _object.all_users !== undefined && _object.all_users) {
        filters = "&all_users=1";
    }
    const response = UsersService.getByTypeProfile(UsersService.typeProfiles.salesman, filters);

    response.then(function (_response) {
        commit('setListSalesmans', _response);
    });

    return response;
};

const getSupervisors = async ({ commit }) => {
    const response = UsersService.getByTypeProfile(UsersService.typeProfiles.supervisor, "");

    response.then(function (_response) {
        commit('setListSupervisors', _response);
    });

    return response;
};

const rem = async ({ commit }, _object) => {
    const response = UsersService.rem(_object.id);

    return response;
};

export default {
    add,
    all,
    edit,
    get,
    getAfterSales,
    getManagers,
    getSalesmans,
    getSupervisors,
    rem
};